import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CisProSearchService } from '../../../../services/cispro-search.service';
import { MatDialog } from '@angular/material/dialog';
import { CisProSearchComponent } from '../../../cispro-search/cispro-search.component';
import { CisProSearchResult } from '../../../../services/cispro-search.service';
interface ContainerItem {
  value: string;
  searchResults?: any[];
  isSearching?: boolean;
}

@Component({
  selector: 'app-edit.component',
  standalone: true,
  imports: [CommonModule, FormsModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css'],
})
export class EditComponent {
  containers: ContainerItem[] = [];

  constructor(
    public dialogRef: MatDialogRef<EditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { containers: string[] },
    private cisProSearchService: CisProSearchService,
    private dialog: MatDialog
  ) {
    // Initialize containers from existing data - do NOT add empty container initially
    if (data.containers && data.containers.length > 0) {
      this.containers = data.containers
        .filter(c => c && c.trim().length > 0)
        .map(c => ({ value: c, searchResults: [], isSearching: false }));
    }
    // Start with empty array - containers will be added when user clicks "Add" button
  }

  addContainer(): void {
    this.containers.push({ value: '', searchResults: [], isSearching: false });
  }

  removeContainer(index: number): void {
    this.containers.splice(index, 1);
  }
  clearContainerValue(index: number): void {
  this.containers[index].value = '';
  this.containers[index].searchResults = [];
}

  onContainerFocus(index: number): void {
    // Clear search results when focusing on a different container
    this.containers.forEach((c, i) => {
      if (i !== index) {
        c.searchResults = [];
      }
    });
  }

 
  searchContainer(index: number): void {

  const dialogRef = this.dialog.open(CisProSearchComponent, {
    width: '90vw',
    maxWidth: '1200px',
    autoFocus: false
  });

  dialogRef.afterClosed().subscribe(
    (result: CisProSearchResult | undefined) => {

      if (!result) {
        return;
      }

      this.containers[index].value = result.barcodeId;
    }
  );
}

  selectSearchResult(index: number, result: any): void {
    this.containers[index].value = result.barcodeId;
    this.containers[index].searchResults = [];
  }

  save(): void {
    // Filter out empty containers and return the values
    const validContainers = this.containers
      .map(c => c.value?.trim())
      .filter(v => v && v.length > 0);
    
    this.dialogRef.close(validContainers);
  }
}